import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5db2d2c8")

_pushScopeId("data-v-5db2d2c8")
const _hoisted_1 = { class: "nav-container flexbox-row justify-space-between padding-bottom-20 padding-top-20" }
const _hoisted_2 = { class: "title color-white barlow" }
const _hoisted_3 = { class: "button-text montserrat" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "file_download", -1)
_popScopeId()

import { convertArrayIntoCsv } from "@/services/files.service";
import {
  mapUsersArray,
  uppercase,
} from "@/services/mapping.service";
import { ActionTypes } from "@/store/action-types";
import { useStore } from "@/store/store";
import { computed, ref } from "vue";
import UsersList from "@/components/users-list/UsersList.vue";
import { useI18n } from "vue-i18n";


export default _defineComponent({
  setup(__props) {

const store = useStore();
const { t } = useI18n();

/* COMPUTED */
const myClubId = computed(function (): string {
  return store.getters.getMyClub.club_id;
});

const membActive = computed(function (): boolean {
  return store.getters.getMyClub.membership_attiva;
});

function constructPayload(payload) {
  const _payload = { ...payload };
  return _payload;
}

async function fetchAllUsers() {
  try {
    let usr = {
      values: [],
    };
    let last_evaluated_key = undefined;
    let isFirstCycle = true;
    while (last_evaluated_key || isFirstCycle) {
      isFirstCycle = false;
      const _values = await store.dispatch(ActionTypes.GET_USERS, {
        club_id: myClubId.value,
        filters: constructPayload({ limit: 10000 }),
      });
      last_evaluated_key = _values.last_evaluated_key;
      usr = {
        values: usr.values.concat(_values.values.filter((el) => !!el.name)),
      };
    }
    return usr;
  } catch (err) {
    return err;
  }
}

async function exportData() {
  try {
    const users = (await fetchAllUsers()) as any;

    convertArrayIntoCsv(mapUsersArray(users.values, t), "users_list");
  } catch (err) {
    return;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("p", _hoisted_2, _toDisplayString(_unref(t)('users')), 1),
      (_unref(membActive))
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "cursor-pointer color-blue flexbox-row align-center",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (exportData()))
          }, [
            _createVNode("span", _hoisted_3, _toDisplayString(_unref(uppercase)(_unref(t)('export'))), 1),
            _hoisted_4
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(UsersList, {
      "mask-users-data": !_unref(membActive)
    }, null, 8, ["mask-users-data"])
  ], 64))
}
}

})